<template>
  <div class="bossbox" style="background-color: #24252c;">
    <div class="tablelist">
      <el-table ref="filterTable" :data="tableData" style="width: 100%;margin-top: 45px;" :row-class-name="tableRowClassName" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(25, 26, 31, 0.8)">
        <el-table-column prop="created_at" label="标题" width="350px"  column-key="date">
          <template slot-scope="scope">
            <!-- {{scope.row.realname}} -->
            <img v-if="scope.row.head_img" :src="scope.row.head_img" style="width: 50px;height: 50px;" alt="">
            <img v-else src="../../../static/img2/tx.png" style="width: 50px;height: 50px;" alt="">
          </template>
        </el-table-column>
        <el-table-column label="内容" prop="realname" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="状态" prop="realname" width="80px">
          <template slot-scope="scope">
            <span>已读</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80px" >
          <template slot-scope="scope">
            <a size="mini" style="color:#C0C4CC;cursor:pointer;" @click="toogleExpand(scope.row, scope.$index)">查看</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <notificationsinfor :dialogVisiblemess="dialogVisiblemess" @lcclick="lcclick" :row="row"/>
  </div>
</template>

<script>
import notificationsinfor from '../User/notificationsinfor.vue'
export default {
  components: { notificationsinfor },
  name: 'notifications',
  data() {
    return {
      loading: true,
      tableData: [],
      loading: true,
      desc: '',
      dialogVisiblemess:false,
      row:{}
    }
  },

  methods: {
    // 点击了回复
    toogleExpand(row) {
      this.row=row
      this.dialogVisiblemess=true
    },
    // 关闭弹框
    lcclick(){
      this.dialogVisiblemess=false
    },
    tableRowClassName({ row, rowIndex }) {
      if ((rowIndex%2)===0) {
        return 'warning-row'
      } else {
        return 'success-row'
      }
      return ''
    },
    getScore() {
      this.$http.getteacher().then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.tableData = res.data
          this.loading = false
        } else {
          this.$message.error(res.message)
        }
      })
    },
  },
  mounted() {
    this.getScore()
  },
  created() {},
}
</script>

<style lang="less" >
.el-table__expand-icon {
  display: none;
}
/deep/ .el-table tbody tr:hover > td {
  background-color: #f5f5f5 !important //修改成自己想要的颜色即可
;
}



@media screen and (max-width: 768px) {
  .tablelist {
    width: 92%;
    margin: auto;
    overflow: hidden;
    display: none;
    background: #24252c;
    .el-table .warning-row {
      background: #24252c;
      color: rgb(203, 200, 200);
    }

    .el-table .success-row {
      background: #2a2b32;
      color: rgb(203, 200, 200);
    }
  }
  .tablelistt {
    width: 92%;
    height: 100%;
    margin: auto;
    overflow: hidden;
    .el-table .warning-row {
      background: #24252c;
      color: rgb(203, 200, 200);
    }

    .el-table .success-row {
      background: #2a2b32;
      color: rgb(203, 200, 200);
    }
  }

  .bottomtion111 {
    height: 65px;
    width: 100%;
    background-color: #2f3037;
    //  margin-top: 20px;
    position: absolute;
    bottom: 0;
    // z-index: 1000;
    display: flex;
    justify-content: center;
  }
  .el-pagination {
    margin: auto;
  }
}
@media screen and (min-width: 768px) {
  .tablelist {
    width: 1216px;
    margin: auto;
    background: #24252c;
    .el-table .warning-row {
      background: #24252c;
      color: rgb(203, 200, 200);
    }

    .el-table .success-row {
      background: #2a2b32;
      color: rgb(203, 200, 200);
    }
  }
  .tablelistt {
    width: 92%;
    height: 240rem;
    margin: auto;
    display: none;
    overflow: hidden;
    .el-table .warning-row {
      background: #24252c;
      color: rgb(203, 200, 200);
    }

    .el-table .success-row {
      background: #2a2b32;
      color: rgb(203, 200, 200);
    }
  }

  .bottomtion111 {
    height: 65px;
    width: 100%;
    background-color: #2f3037;
    //  margin-top: 20px;
    position: absolute;
    bottom: 0;
    // z-index: 1000;
    display: flex;
    justify-content: center;
  }
  .el-pagination {
    margin: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/User/notifications.vue